import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import UserServices from "../../../services/UserServices";
import Swal from "sweetalert2";
import UseEditModal from './UseEditModal';
import Select from 'react-select';
import Loader from "../Loader/loader";
import Pagination from "../Pagenation/Pagenation";
import * as XLSX from "xlsx";

const UserPending = ({
  activeTab,
  setActiveTab,
  setShowAddModal,
}) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [sort, setsort] = useState(100); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const loggedInRole = (() => {
    try {
      const loggedInUser = JSON.parse(
        localStorage.getItem("userDetails") || "null"
      );

      return String(loggedInUser?.data?.user?.role || "")
        .trim()
        .toLowerCase();
    } catch {
      return "";
    }
  })();

  const isAccounts = loggedInRole === "accounts";

  const canEditUser = (user) => {
    if (!user?._id) return false;

    const targetRole = String(user.role || "")
      .trim()
      .toLowerCase();

    const isCashUser = [
      "cashmaker",
      "cashchecker"
    ].includes(targetRole);

    return isCashUser ? isAccounts : !isAccounts;
  };

  const canDownloadUsers = [
    "accounts",
    "superadmin"
  ].includes(loggedInRole);

  const [downloadingUsers, setDownloadingUsers] = useState(false);
  const downloadInProgress = useRef(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);

        const response = await UserServices.getAllUser();
        const allUsers = response?.data?.data || [];

        const filteredPendingUsers = allUsers.filter((user) => {
          const normalizedRole = String(user.role || "")
            .trim()
            .toLowerCase();

          const isCashUser = [
            "cashmaker",
            "cashchecker"
          ].includes(normalizedRole);

          return (
            user.status === "inactive" &&
            (!isAccounts || isCashUser)
          );
        });
        setPendingUsers(filteredPendingUsers);

        setPendingUsers(filteredPendingUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [test]);

  // Search code
  const filteredSearch = pendingUsers.filter(user =>
    user?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Options for row selections
  const options = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ];

  // Pagination setup
  useEffect(() => {
    if (pendingUsers.length > 0) {
      activePag.current = 0;
    }
  }, [pendingUsers]);

  // Calculate total pages
  const pagination = Math.ceil(filteredSearch.length / sort);

  useEffect(() => {
    activePag.current = 0;
    activePag.current = 0;
  }, [searchTerm]);


  // Handle page click
  const onClick = (i) => {
    activePag.current = i;
    setTest(prev => prev + 1);
  };

  // Handle deleting user
  function handleDelete(e, user) {
    Swal.fire({
      title: 'Are you sure to delete?',
      text: "You will not be able to recover this User Again!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dd6b55',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        UserServices.deleteUser(user._id).then(() => {
          setTest(prev => prev + 1)
          Swal.fire('Deleted!', 'User has been deleted.', 'success');
        }).catch((error) => {
          console.log(error);
          Swal.fire('Error!', 'There was a problem deleting the user.', 'error');
        });
      }
    });
  }

  const handleStatusToggle = async (user) => {
    const newStatus = user.status === "inactive" ? "active" : "inactive";

    try {
      await UserServices.updateUser(user._id, {
        status: newStatus, // ✅ send ONLY what is required
      });

      setTest(prev => prev + 1); // refresh list
      Swal.fire('Success!', `User status updated to ${newStatus}.`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error!', 'There was a problem updating the user status.', 'error');
    }
  };
  const handleDownloadPendingUsers = async () => {
    if (!canDownloadUsers || downloadInProgress.current) return;

    // Export pending data only, including current search filters.
    const usersToExport = filteredSearch.filter(
      (user) => user.status === "inactive"
    );

    if (usersToExport.length === 0) {
      Swal.fire(
        "Info",
        "No pending users available to download.",
        "info"
      );
      return;
    }

    downloadInProgress.current = true;
    setDownloadingUsers(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 50));

      const rows = [
        [
          "S.No",
          "User Role",
          "Name",
          "Email",
          "Store",
          "Mobile No.",
          "Status"
        ],
        ...usersToExport.map((user, index) => [
          index + 1,
          user.role || "",
          user.name || "",
          user.email || "",
          Array.isArray(user.store)
            ? user.store
              .map((store) => store?.name || "")
              .filter(Boolean)
              .join(", ")
            : "",
          String(user.mobileNo ?? ""),
          user.status
        ])
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(rows);

      worksheet["!cols"] = [
        { wch: 8 },
        { wch: 20 },
        { wch: 28 },
        { wch: 38 },
        { wch: 50 },
        { wch: 18 },
        { wch: 14 }
      ];

      worksheet["!autofilter"] = {
        ref: `A1:G${rows.length}`
      };

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Pending Users"
      );

      const today = new Date();

      const date = [
        today.getFullYear(),
        String(today.getMonth() + 1).padStart(2, "0"),
        String(today.getDate()).padStart(2, "0")
      ].join("-");

      XLSX.writeFile(
        workbook,
        `Pending_Users_${date}.xlsx`
      );

      Swal.fire({
        icon: "success",
        title: "Excel File Ready",
        text: "The file has been generated. Please check your browser downloads.",
        timer: 2500,
        showConfirmButton: false
      });
    } catch (error) {
      console.error("Pending user download failed:", error);

      Swal.fire(
        "Error",
        "Unable to download pending users. Please try again.",
        "error"
      );
    } finally {
      downloadInProgress.current = false;
      setDownloadingUsers(false);
    }
  };

  const handleEditClick = (user) => {
    if (!canEditUser(user)) return;

    setSelectedItem(user);
    setGridInsideModal(true);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <>
      <UseEditModal
        admin={selectedItem}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => {
          setGridInsideModal(false);
          setSelectedItem(null);
        }}
      />

      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link to={"#"} className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-xxl-6">
                      <input type="text"
                        className="form-control mb-xl-0 mb-3"
                        id="exampleFormControlInput1"
                        placeholder="Search by name, email, or role..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          activePag.current = 0;
                        }}
                      />
                    </div>
                    <div className="col-xl-3 col-xxl-6">
                      <Select
                        placeholder="Select row to display in User Table"
                        value={options.find(option => option.value === sort)} // set the current selected value
                        // onChange={(selectedOption) => setsort(selectedOption.value)} // update `sort` on selection
                        onChange={(selectedOption) => {
                          setsort(Number(selectedOption.value));
                          activePag.current = 0;
                          setTest(prev => prev + 1);
                        }}
                        isSearchable={false}
                        options={options}
                        className="custom-react-select mb-3 mb-xxl-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className="content-title user-header-line">
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true" />
                Pending User
                <span className="badge bg-orange ms-2">
                  {filteredSearch.length}
                </span>
              </div>

              <div className="user-header-tabs">
                <button
                  type="button"
                  className={activeTab === "active" ? "is-active" : ""}
                  onClick={() => setActiveTab("active")}
                >
                  Active Users
                </button>

                <button
                  type="button"
                  className={activeTab === "inactive" ? "is-active" : ""}
                  onClick={() => setActiveTab("inactive")}
                >
                  Pending Users
                </button>
              </div>

              <div className="user-header-icons">
                {canDownloadUsers && (
                  <button
                    type="button"
                    className="user-header-icon"
                    onClick={handleDownloadPendingUsers}
                    disabled={
                      downloadingUsers || filteredSearch.length === 0
                    }
                    title={
                      downloadingUsers
                        ? "Preparing Excel…"
                        : "Download Pending Users"
                    }
                    aria-label={
                      downloadingUsers
                        ? "Preparing Excel…"
                        : "Download Pending Users"
                    }
                    aria-busy={downloadingUsers}
                  >
                    {downloadingUsers ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        aria-hidden="true"
                      />
                    ) : (
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="M12 3v12" />
                        <path d="m7 10 5 5 5-5" />
                        <path d="M5 16v4h14v-4" />
                      </svg>
                    )}
                  </button>
                )}

                <button
                  type="button"
                  className="user-header-icon user-header-add"
                  onClick={() => setShowAddModal(true)}
                  title="Add New User"
                  aria-label="Add New User"
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    aria-hidden="true"
                  >
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </button>

                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"
                      }`}
                    onClick={(event) => {
                      event.preventDefault();
                      setOpen2((previous) => !previous);
                    }}
                    title={open2 ? "Hide table" : "Show table"}
                    aria-label={open2 ? "Hide table" : "Show table"}
                    aria-expanded={open2}
                  >
                    <i className="fas fa-angle-up" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div id="content_wrapper" className="dataTables_wrapper no-footer">
                      <div className="scrolltable">
                        <table
                          className="table table-bordered table-responsive-lg table-striped table-condensed flip-content user-list-table"
                          id="pending-users-data"
                        >
                          <thead className="sticky-table-header">
                            <tr>
                              <th>S.No</th>
                              <th>User Details</th>
                              <th>Store</th>
                              <th>Mobile No.</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredSearch.length > 0 ? (
                              filteredSearch
                                .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                .map((user, index) => (
                                  <tr key={index}>
                                    <td>{activePag.current * sort + index + 1}</td>
                                    <td className="user-details-cell">
                                      <div className="user-details-content">
                                        <div className="mb-1">
                                          <strong>Role:</strong> {user?.role || "—"}
                                        </div>

                                        <div className="mb-1">
                                          <strong>Name:</strong> {user?.name || "—"}
                                        </div>

                                        <div>
                                          <strong>Email:</strong> {user?.email || "—"}
                                        </div>
                                      </div>
                                    </td>

                                    <td className="scrollable-description">
                                      {user?.store?.length > 0
                                        ? user.store.map((store) => store.name).join(", ")
                                        : "No Stores"}
                                    </td>

                                    <td>{user?.mobileNo || "—"}</td>
                                    <td>
                                      <span
                                        onClick={() => handleStatusToggle(user)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <i
                                          className={`fa ${user.status === 'inactive' ? 'fa-circle text-danger' : 'fa-circle text-success'}`}
                                          title={user.status === 'inactive' ? 'Inactive' : 'Active'}
                                        ></i>
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-xs sharp"
                                        disabled={!canEditUser(user)}
                                        onClick={() => handleEditClick(user)}
                                        title={
                                          canEditUser(user)
                                            ? "Edit User"
                                            : "You do not have permission to edit this user"
                                        }
                                        aria-label="Edit User"
                                        style={{
                                          opacity: canEditUser(user) ? 1 : 0.4,
                                          cursor: canEditUser(user) ? "pointer" : "not-allowed"
                                        }}
                                      >
                                        <i className="fa fa-pencil" aria-hidden="true" />
                                      </button>

                                      {/* Delete temporarily hidden
  <button
    className="btn btn-danger btn-xs sharp"
    onClick={(e) => handleDelete(e, user)}
  >
    <i className="fa fa-trash"></i>
  </button>
  */}
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No Pending Users Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          {filteredSearch.length > 0 ? (
                            <>
                              Showing {activePag.current * sort + 1} to{" "}
                              {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of{" "}
                              {filteredSearch.length} entries
                            </>
                          ) : (
                            <>Showing 0 to 0 of 0 entries</>
                          )}
                        </div>
                        {/* <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className="paginate_button previous"
                            to="#"
                            onClick={() =>
                              activePag.current > 0 && onClick(activePag.current - 1)
                            }
                          >
                            <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                          </Link>
                          <span>
                            {Array.from({ length: pagination }, (_, i) => (
                              <Link
                                key={i}
                                to="#"
                                className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                onClick={() => onClick(i)}
                              >
                                {i + 1}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="#"
                            onClick={() =>
                              activePag.current + 1 < pagination && onClick(activePag.current + 1)
                            }
                          >
                            <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                          </Link>
                        </div> */}
                        <Pagination activePage={activePag.current}
                          totalPages={pagination}
                          onPageChange={onClick} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPending;
